import { motion } from 'framer-motion';

const LoadingSpinner = ({ label = 'Syncing Inventory...' }: { label?: string }) => {
    return (
        <div className="flex flex-col items-center justify-center min-h-[400px] w-full bg-transparent">
            <div className="relative w-16 h-16 mb-8">
                {/* Navy Circle */}
                <motion.div
                    animate={{
                        x: [-12, 12, -12],
                        scale: [1, 1.1, 1],
                        opacity: [0.8, 1, 0.8]
                    }}
                    transition={{
                        duration: 1.5,
                        repeat: Infinity,
                        ease: "easeInOut"
                    }}
                    className="absolute inset-0 m-auto w-10 h-10 rounded-full bg-[#1E4164] mix-blend-multiply"
                />
                {/* Terracotta Circle */}
                <motion.div
                    animate={{
                        x: [12, -12, 12],
                        scale: [1.1, 1, 1.1],
                        opacity: [0.8, 1, 0.8]
                    }}
                    transition={{
                        duration: 1.5,
                        repeat: Infinity,
                        ease: "easeInOut"
                    }}
                    className="absolute inset-0 m-auto w-10 h-10 rounded-full bg-[#F0511B] mix-blend-multiply"
                />
            </div>
            
            {label && (
                <motion.div
                    initial={{ opacity: 0, y: 5 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.2 }}
                    className="flex flex-col items-center gap-2"
                >
                    <span className="text-[13px] font-bold text-[#1E4164]">
                        {label}
                    </span>
                    <div className="flex gap-1">
                        {[0, 1, 2].map((i) => (
                            <motion.div
                                key={i}
                                animate={{ opacity: [0.3, 1, 0.3] }}
                                transition={{
                                    duration: 1,
                                    repeat: Infinity,
                                    delay: i * 0.2
                                }}
                                className="w-1 h-1 rounded-full bg-[#F0511B]"
                            />
                        ))}
                    </div>
                </motion.div>
            )}
        </div>
    );
};

export default LoadingSpinner;
